import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useAccount } from '@/hooks/useAccount.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { drinkOfferSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';
import { userService } from '@/services/user';

import { HARDCODED_CATEGORIES } from '../../constants';

export const DrinkOfferScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const { refreshUser } = useAccount();

  const handleNextStep = () => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    refreshUser();
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/drink-offer-scene.png`}
      title={[
        { text: 'He walks over. ', italic: true },
        { text: 'Drink?', italic: false },
      ]}
      choices={drinkOfferSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
